import { useState } from "react";
import { Button, ResourceContextProvider, SaveButton, SimpleForm, Title, Toolbar, useNotify } from "react-admin";
import {
  Box,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { studentRequests } from "api/studentApi";
import { getFileFromUrl } from "server/components/DownloadFile";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import SearchStudentStep from "./SearchStudentStep";
import SaveForm from "./SaveForm";
import { DocumentTypeLabels, DocumentTypes } from "./documentTypes";

const GenerateDocumentToolbar = () => (
  <Toolbar>
    <SecuredComponent permission={permissions.canGenerateAcademicRequestDocuments}>
      <SaveButton
        label="Генерирай документ"
        icon={<FileDownloadIcon />}
      />
    </SecuredComponent>
  </Toolbar>
);

const GraduatedStudentDocuments = () => {
  const notify = useNotify();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const [documentType, setDocumentType] = useState(DocumentTypes.AcademicReference);
  const [showForm, setShowForm] = useState(false);

  const handleCreate = () => {
    setShowForm(true);
  };

  const handleBack = () => {
    setShowForm(false);
    setDocumentType(DocumentTypes.AcademicReference);
  };

  const handleSubmit = async data => {
    // getFileFromUrl notifies on its own failure, so no separate error handling is added here.
    const url = `${settings.gatewayApi}/${studentRequests.postManualAcademicReport()}`;
    await getFileFromUrl(url, "академична-справка", notify, "POST", data);
  };

  return (
    <Box>
      <Title title="Документи за дипломирани студенти" />

      <Box sx={settings.style.InputCardStyle}>
        <Card sx={{ width: isMobile ? "100%" : "760px" }}>
          <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontWeight: "bold" }}>Избран тип документ</Typography>
            <FormControl>
              <RadioGroup
                row
                value={documentType ?? ""}
                onChange={e => setDocumentType(e.target.value)}
              >
                <FormControlLabel
                  value={DocumentTypes.AcademicReference}
                  control={<Radio />}
                  disabled={showForm}
                  label={DocumentTypeLabels[DocumentTypes.AcademicReference]}
                />
              </RadioGroup>
            </FormControl>
          </CardContent>
        </Card>
      </Box>

      {documentType && !showForm && <SearchStudentStep onCreate={handleCreate} />}

      {showForm && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2 }}>
          <Typography
            variant="h6"
            sx={{ textAlign: "center" }}
          >
            {DocumentTypeLabels[documentType]}
          </Typography>
          <Button
            label="Назад"
            variant="contained"
            size="medium"
            color="error"
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
          />
        </Box>
      )}

      {showForm && (
        <ResourceContextProvider value="graduated-student-documents">
          <SimpleForm
            onSubmit={handleSubmit}
            toolbar={<GenerateDocumentToolbar />}
          >
            <SaveForm />
          </SimpleForm>
        </ResourceContextProvider>
      )}
    </Box>
  );
};

export default GraduatedStudentDocuments;
